var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.34796L9.17085 0L7.60972 1.56113L0.5 8.65204V12H3.84796L11.2022 4.66458L12.5 3.34796ZM11.4467 3.34796L10.6567 4.13793L8.38088 1.84326L9.15204 1.05329L11.4467 3.34796ZM1.25235 9.72414L2.81348 11.2476H1.25235V9.72414ZM3.69749 11.0784L1.38401 8.82132L7.83542 2.38871L10.1301 4.66458L3.69749 11.0784Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e67caded4a8659ae59042dbb127b881c.svg";
export { ForwardRef as ReactComponent };